<template>

  <van-cascader v-if='columns.length' title="选择仓库" :options="columns" :field-names="fieldNames" v-model="wares" :closeable="false"  @change="onChange"/>
  <van-empty v-else :image="require('@/assets/image/empty.png')" description="暂无仓库" />
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { Toast } from 'vant';
  import { iscode } from '@/utils/app.js';
	import { getWarehousePosition } from '@/api/public.js';
  import {useWare} from '@/hooks/function.js'
  export default {
		name:"selectWarehouse",
    props:{
      showChild:{
        type:Number
      }
    },
    setup(props, { emit }) {
      const state = reactive({
        columns: [],
        fieldNames:{},
        wares:{}
      })
      const getList = async() =>{
        let result = await useWare().getWareList(props.showChild)
        if (iscode(result)) {
          if(props.showChild == 1){
            state.fieldNames = {text: 'name', value: 'id',children:'child'}
            result.data.map(v=>{v.child = v.child || []})
          }else{
            state.fieldNames = {text: 'name', value: 'id'}
          }
					state.columns = result.data;
				}else{
          Toast.fail(result.msg);
				}
      }
      const cancel = () =>{
        emit("cancel");
      }
      const onChange=(e)=>{
        emit("confirm",e.selectedOptions);
      }
      onMounted(() => {
        getList();
      })
      return {
        ...toRefs(state),
        confirm,
        cancel,
        onChange
      };
    }
  };
</script>
